import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './LoginNotificationBanner.module.css';
import { NamedLink } from '../index';
import { FormattedMessage } from '../../util/reactIntl';

const LoginNotificationBanner = props => {
  const { className, rootClassName, content, type } = props;
  const classes = classNames(rootClassName || css.root, css.warning, css.alert);

  return (
    <div className={classes}>
      <FormattedMessage id="StripePayoutPage.loginBanner" />
      <NamedLink name="LoginPage" className={css.loginLink}>
        <FormattedMessage
          id="LoginNotificationBanner.warning"
          values={{
            br: <br />,
          }}
        />
      </NamedLink>
    </div>
  );
};

const { number, string } = PropTypes;

LoginNotificationBanner.defaultProps = {
  className: null,
  rootClassName: null,
};

LoginNotificationBanner.propTypes = {
  content: string,
  className: string,
  rootClassName: string,
  type: string,
};
export default LoginNotificationBanner;
